export const TYPES = {
  CustomerIORepository: Symbol.for('CustomerIORepository'),
  CustomerIOUseCases: Symbol.for('CustomerIOUseCases'),
};
